import { Blackboard } from "./Blackboard";
import { evaluate } from "./ExprEval";
import { Ternary } from "./Ternary";
import type { TriggerDefinition } from "./Interpreter";

export interface TriggerMatch {
  scene: string;
  trigger: TriggerDefinition;
}

export class TriggerEngine {
  private _triggers: TriggerDefinition[] = [];

  load(triggers: TriggerDefinition[]): void {
    this._triggers = [...triggers].sort((a, b) => specificity(b) - specificity(a));
  }

  evaluate(entity: string, verb: string, room: string, bb: Blackboard): TriggerMatch | null {
    for (const t of this._triggers) {
      if (!matches(t.entity, entity)) continue;
      if (!matches(t.verb, verb)) continue;
      if (!matches(t.room, room)) continue;

      if (t.cond_ast) {
        const result = evaluate(t.cond_ast, bb);
        const ternary = result instanceof Ternary ? result : Ternary.from(result);
        if (!ternary.isTrue) continue;
      }

      return { scene: t.scene, trigger: t };
    }
    return null;
  }

  clear(): void {
    this._triggers = [];
  }
}

function matches(pattern: string, value: string): boolean {
  return pattern === "*" || pattern === value;
}

function specificity(t: TriggerDefinition): number {
  let score = 0;
  if (t.entity !== "*") score += 4;
  if (t.verb !== "*") score += 2;
  if (t.room !== "*") score += 1;
  return score;
}
